import { AbstractControl, ValidatorFn } from '@angular/forms';
import { Equipment } from '../../../../models/equipment.model';
import { DamageType, Mode } from '../../../../models/mode.model';
import { ToastrService } from '../../../../services/toastr-service';
import { ApplicationtTextService } from '../../../../services/application-text.service';

export function ptiStatusValidator(
  equipment: Equipment | null,
  mode: Mode | null,
  toastrService: ToastrService,
  appTextSvc: ApplicationtTextService,
): ValidatorFn {
  return (control: AbstractControl) => {
    // Additional condition: DRY equipment + "Release to booking" description
    if (
      ((equipment?.equipmentTypeCode?.toUpperCase() === 'DRY' || equipment?.equipmentTypeCode?.toUpperCase() === 'REEF') &&
        equipment?.ptiStatus?.description.toUpperCase() === 'RELEASE TO BOOKING') ||
      equipment?.ptiStatus?.color.toUpperCase() === 'BLUE'
    ) {
      toastrService.showToastr(appTextSvc.ptiStatusValidatorForDryAndReef, 'warning', { duration: 60000 });
    }

    const enteredRepairCode = control.value as string;
    if (!enteredRepairCode || !equipment?.ptiStatus) return null;

    // Skip validation for Structural mode
    if (mode?.damageType === DamageType.STRUCTURAL) return null;

    const { color, description } = equipment.ptiStatus;

    let raiseWarning = false;
    if (
      color === 'Green' &&
      (enteredRepairCode === PtiRepairCodeMapping['ShortPTI'] || enteredRepairCode === PtiRepairCodeMapping['LongPTI'])
    ) {
      raiseWarning = true;
    } else if (color === 'Red') {
      if (
        (description === 'Short PTI' &&
          (enteredRepairCode === PtiRepairCodeMapping['VisualInspection'] || enteredRepairCode === PtiRepairCodeMapping['LongPTI'])) ||
        (description === '*PTI/SPTI' &&
          (enteredRepairCode === PtiRepairCodeMapping['VisualInspection'] || enteredRepairCode === PtiRepairCodeMapping['ShortPTI']))
      ) {
        raiseWarning = true;
      }
    }

    if (raiseWarning) {
      toastrService.showToastr(appTextSvc.ptiStatusValidator, 'warning', { duration: 60000 });
    }

    return null;
  };
}

export const PtiRepairCodeMapping: Record<string, string> = {
  VisualInspection: '0948',
  ShortPTI: '0942',
  LongPTI: '0940',
};
